import React from 'react';
import { Box, Button, Card, CardContent, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import GoogleIcon from '@mui/icons-material/Google';

export default function Login() {
  const [emailOptIn, setEmailOptIn] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const location = useLocation();
  const isMobile = window.innerWidth <= 768;

  const getGoogleAuthUrl = () => {
    const baseUrl = process.env.REACT_APP_API_URL + '/auth/google';
    const params = new URLSearchParams();
    if (emailOptIn) {
      params.append('emailOptIn', '1');
    }
    // Get returnTo from query params
    const searchParams = new URLSearchParams(location.search);
    const returnTo = searchParams.get('returnTo');
    const ref = searchParams.get('ref');
    if (returnTo) {
      params.append('returnTo', returnTo);
    }
    if (ref) {
      params.append('ref', ref);
    }
    return params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
  };

  const handleGoogleLogin = () => {
    setIsLoading(true);
    window.location.href = getGoogleAuthUrl();
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: isMobile ? 2 : 4,
      direction: 'rtl'
    }}>
      <Card sx={{
        maxWidth: 500,
        width: '100%',
        borderRadius: 4,
        boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
        background: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(10px)'
      }}>
        <CardContent sx={{ p: isMobile ? 3 : 5, textAlign: 'center' }}>
          {/* Logo/Title */}
          <Typography variant="h3" sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold',
            mb: 2,
            fontSize: isMobile ? 32 : 40
          }}>
            أمير ماستر
          </Typography>

          <Typography variant="body1" sx={{
            mb: 4,
            color: '#4a5568',
            fontSize: isMobile ? 16 : 18,
            lineHeight: 1.6
          }}>
            منصة التحضير الأفضل لامتحان أمير<br />
            سجّل الدخول الآن وابدأ التحضير بذكاء
          </Typography>

          {/* Google Sign In Button */}
          <Button
            variant="contained"
            size="large"
            startIcon={<GoogleIcon />}
            onClick={handleGoogleLogin}
            disabled={isLoading}
            sx={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: isMobile ? 16 : 18,
              borderRadius: 3,
              padding: '14px 32px',
              boxShadow: '0 8px 32px rgba(102, 126, 234, 0.4)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5568d3 0%, #663a8e 100%)',
                boxShadow: '0 12px 40px rgba(102, 126, 234, 0.6)',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.3s ease',
              mb: 3,
              width: '100%',
              direction: 'rtl'
            }}
          >
            {isLoading ? 'جارٍ التحميل...' : 'تسجيل الدخول عبر Google'}
          </Button>

          {/* Email Opt-in Checkbox */}
          <FormControlLabel
            control={
              <Checkbox
                checked={emailOptIn}
                onChange={(e) => setEmailOptIn(e.target.checked)}
                sx={{
                  color: '#667eea',
                  '&.Mui-checked': {
                    color: '#667eea',
                  },
                }}
              />
            }
            label={
              <Typography sx={{ fontSize: 14, color: '#4a5568', textAlign: 'right' }}>
                أوافق على تلقي تحديثات ومحتوى تعليمي عبر البريد الإلكتروني
              </Typography>
            }
            sx={{ mb: 2 }}
          />

          {/* Free Trial Notice */}
          <Box sx={{
            background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
            color: '#8b4513',
            borderRadius: 3,
            padding: 2,
            fontSize: 14,
            textAlign: 'right',
            border: '1px solid rgba(252, 182, 159, 0.3)'
          }}>
            <strong>🎁 عرض خاص:</strong><br />
            احصل على <strong>3 أيام تجريبية مجانية</strong> عند التسجيل لأول مرة!
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
